<template>
  <div class="loading-container">
    <!-- 加载动画：请求未完成时显示 -->
    <div class="loading-spinner" v-if="isLoading"></div>
    
    <!-- 动态提示文字：根据状态切换内容 -->
    <p class="loading-text">
      {{ isLoading ? text : (errorMsg || (payStatus === 0 ? '共享仓货品还未支付请先支付后激活!' : '跳转中...')) }}
    </p>

    <!-- 购买按钮：仅当 pay_status=0 时显示 -->
    <button 
      class="buy-btn" 
      v-if="payStatus === 0 && !isLoading && !errorMsg"
      @click="handleBuy"
    >
      直接购买
    </button>

      <button 
      class="buy-btn" 
      v-if="payStatus === 0 && !isLoading && !errorMsg"
      @click="handleToActivate"
    >
      激活商品
      </button>
  </div>
</template>

<script>

export default {
  name: 'PayStatusRedirect',
  props: {
    size: {
      type: String,
      default: '10vw',
      description: '转圈效果的尺寸（如 "8vw"、"40px"）'
    },
    color: {
      type: String,
      default: '#08cd7e',
      description: '转圈边框及购买按钮的主题色'
    },
    showText: {
      type: Boolean,
      default: true,
      description: '是否显示提示文字'
    },
    text: {
      type: String,
      default: '加载中...',
      description: '默认加载文字'
    }
  },
  data() {
    return {
      isLoading: true, // 控制加载动画显示/隐藏
      payStatus: null, // 存储接口返回的 pay_status
      errorMsg: '', // 存储错误提示（如“查找不到商品”）
      sn: '', // 存储URL中的sn参数
      wx_url:"",
      activate_url :'',
      shop_id:'',
      params1:'',
      params2:'',
      other_id:''
    };
  },
  created() {
     const fullDomain = window.location.origin
     const fullUrl = window.location.href; 
     this.sn  = ""
     if(fullUrl.indexOf(fullDomain+"/shop/#/skip/")>-1){
       this.sn  = fullUrl.replace(fullDomain+"/shop/#/skip/","")

     }else{
       this.sn  = fullUrl.replace(fullDomain+"/#/skip/","")
     }
     this.other_id = this.$route.params.other_id;
     console.log(this.sn)
    this.shop_id = this.$route.params.shop_id; 
    if (this.sn == "") {
      this.isLoading = false;
      this.errorMsg = '缺少商品参数，无法查询';
      return;
    }

    // 2. 发起接口请求，获取pay_status
    this.fetchPayStatus();
  },
  methods: {
    // 发起接口请求：查询商品的pay_status
    async fetchPayStatus() {
      try {
        const res = await this.$get(`${this.$api.find_by_sn}?shop_id=${this.shop_id}&other_id=${this.other_id}&sn=${this.sn}`);
        
        // 关闭加载动画
        this.isLoading = false;

        // 3. 处理接口返回结果
        // 情况1：接口返回为空 → 提示“查找不到商品”
        if (!res || !res.data) {
          this.errorMsg = '查找不到该商品，请检查参数';
          return;
        }

        // 情况2：获取pay_status，触发对应逻辑
        this.payStatus = res.data.pay_status; // 假设pay_status在res.data中
        switch (this.payStatus) {
          // 情况2.1：pay_status=1 → 自动跳转到指定链接
          case 1:
            const targetUrl = res.data.url;
            window.location=targetUrl
            // window.open(targetUrl, '_blank');
            break;
          // 情况2.2：pay_status=0 → 显示购买按钮（模板中已通过v-if控制）
          case 0:
            this.wx_url = res.data.url;
            this.activate_url = res.data.activate_url;
            break;
          // 情况2.3：其他未知状态 → 提示错误
          default:
            this.errorMsg = '商品状态异常，请联系客服';
        }

      } catch (err) {
        // 4. 捕获请求错误（如网络异常、接口报错）
        this.isLoading = false;
        this.errorMsg = '加载失败，请稍后重试';
        console.error('请求异常：', err); // 控制台打印错误，便于排查
      }
    },

    // 点击购买按钮：跳转到购买链接（链接可根据实际需求修改）
    handleBuy() {
      // 购买跳转链接：这里默认用“https://cdsuojia.com/1001/购买路径+sn”，可按需调整
      const buyUrl = this.wx_url; 
      window.location=buyUrl 
      // window.open(buyUrl, '_blank');
    },
    handleToActivate() {
      // 激活跳转链接：这里默认用“https://cdsuojia.com/1001/购买路径+sn”，可按需调整
      const activateUrl = this.activate_url; 
      window.location=activateUrl 
      // window.open(activateUrl, '_blank');
    }
  }
};
</script>

<style scoped>
/* 1. 外层容器：保持居中布局 */
.loading-container {
  padding-top:6vh ;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.9);
}

/* 2. 加载动画：仅请求中显示 */
.loading-spinner {
  width: v-bind(size);
  height: v-bind(size);
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top-color: #08cd7e;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* 3. 旋转动画关键帧 */
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 4. 提示文字样式 */
.loading-text {
  margin-top: 2vw;
  font-size: 5vw;
  color: #000000;
  text-align: center;
  padding: 0 2vw; /* 防止文字超出屏幕 */
}

/* 5. 购买按钮样式：主题色、hover效果 */
.buy-btn {
  margin-top: 10vw;
  padding: 4vw 20vw;
  font-size: 3.2vw;
  color: white;
  background-color: #08cd7e;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  transition: background-color 0.3s; /*  hover渐变效果 */
}

.buy-btn:hover {
  background-color: darken(#08cd7e, 10%); /*  hover时颜色加深10% */
}
</style>


// WEBPACK FOOTER //
// src/views/skip/index.vue